import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import header from "../assets/Header.png";
import closeIcon from "../assets/closeIcon.svg";
import tickMark from "../assets/tickMark.svg";
import logo from "../assets/logo.png";
import styles from "./EmailVerification.module.css"; // Changed to module.css
import { resendEmailVerification, verifyEmail } from "../api/emailVerification";
import { toast } from "react-toastify";

// Define verification states as constants
const VERIFICATION_STATE = {
  LOADING: "LOADING",
  VERIFIED: "VERIFIED",
  FAILED: "FAILED",
  SENT: "SENT",
};

const EmailVerification = () => {
  const { userId, token } = useParams();
  const navigate = useNavigate();
  const [verificationState, setVerificationState] = useState(VERIFICATION_STATE.LOADING); // Using constant instead of string
  const [error, setError] = useState(null);

  useEffect(() => {
    if (token) {
      handleVerifyEmail(userId, token);
    } else {
      // No token provided, show resend option
      setVerificationState(VERIFICATION_STATE.FAILED);
    }
  }, [token]);

  const handleVerifyEmail = async (userId, token) => {
    try {
      const response = await verifyEmail(userId, token);
      console.log("response", response);

      if (response.success && response.data?.verified) {
        setVerificationState(VERIFICATION_STATE.VERIFIED);
      } else {
        toast.error(response.message || "Invalid or expired verification token");
        setVerificationState(VERIFICATION_STATE.FAILED);
        setError(response.message || "Invalid or expired verification token");
      }
    } catch (err) {
      console.error("Verification error:", err);
      setVerificationState(VERIFICATION_STATE.FAILED);
      setError("Something went wrong. Please try again.");
    }
  };

  const resendVerificationEmail = async () => {
    try {
      const response = await resendEmailVerification(userId);
      console.log("response", response);
      if (response.isSuccess) {
        setVerificationState(VERIFICATION_STATE.SENT);
      } else {
        toast.error("Invalid or expired verification token"); // Add error toast
        setError("Failed to resend verification email. Please try again.");
      }
    } catch (err) {
      setError("Failed to resend verification email. Please try again.");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.logoContainer}>
          <img src={header} alt="LIFEWINK" className={styles.background} />
          <img src={logo} alt="LIFEWINK" className={styles.logo} />
        </div>

        {verificationState === VERIFICATION_STATE.LOADING && (
          <div className={styles.loadingState}>
            <div className={styles.spinner}></div>
            <p>Verifying your email...</p>
          </div>
        )}

        {verificationState === VERIFICATION_STATE.VERIFIED && (
          <div className={styles.content}>
            <div className={`${styles.icon} ${styles.success}`}>
              <img src={tickMark} alt="tickMark" />
            </div>
            <h2>Email verified</h2>
            <p>Your email address has been verified</p>
            <button className={styles.button} onClick={() => navigate("/")}>
              Go to Home
            </button>
          </div>
        )}

        {verificationState === VERIFICATION_STATE.FAILED && (
          <div className={styles.content}>
            <div className={`${styles.icon} ${styles.error}`}>
              <img src={closeIcon} alt="closeIcon" />
            </div>
            <h2>Email not verified</h2>
            <p>Please try again or click below to receive a new verification email.</p>
            <button className={styles.button} onClick={resendVerificationEmail}>
              Resend verification email
            </button>
          </div>
        )}

        {verificationState === VERIFICATION_STATE.SENT && (
          <div className={styles.content}>
            <h2>A new verification email has been sent to your inbox</h2>
            <p>Please check your email and follow the verification link</p>
            <button className={styles.button} onClick={resendVerificationEmail}>
              Resend again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;
